import { __assign, __rest } from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationCentaurCard from './DeviationCentaurCard';
export var GallectionCentaurCard = function (_a) {
    var gallection = _a.gallection, centaurProps = __rest(_a, ["gallection"]);
    var t = useTranslation().t;
    return (React.createElement(DeviationCentaurCard, __assign({}, centaurProps, { deviation: gallection.thumb || undefined, title: gallection.name, subtitle: t('collectionPanel.card.artworks', { count: gallection.size }) })));
};
GallectionCentaurCard.displayName = 'GallectionCentaurCard';
export default GallectionCentaurCard;
//# sourceMappingURL=GallectionCentaurCard.js.map